import React from 'react';

const NotFound = () => {
	return (
		<div className="container py-5">
			<div className="row justify-content-center">
				<div className="col-md-8 text-center">
					<h1 className="mb-3">404</h1>
					<p className="md-text">The page you requested could not be found.</p>
				</div>
			</div>
		</div>
	);
};

export default NotFound;